/* eslint-disable */
// import DataController from './DataController';

module.exports = {
  getHTMLForTable(tableSection, GLID, selectedAge, reverse, trust, annotations) {
    if (tableSection) {
      let type = tableSection["Type"];
      if (type === "table") {
        // let glTable = tableSection.rowColData;
      } else if (type === "DrugTable") {
        let tableHTML = this.tableAndBoxesReverse(
          tableSection,
          799,
          1,
          GLID,
          true,
          reverse,
          selectedAge,
          trust,
          annotations
        );
        return tableHTML;
      } else {
        alert("Unknown table type!");
      }

      return "";
    }
  },

  getDrugTable(drugGuideline) {
    const result = [];

    if (drugGuideline.sections !== undefined) {
      for (let i = 0; i < drugGuideline.sections.length; i++) {
        const section = drugGuideline.sections[i];

        if (section.TableAndBoxes !== undefined) {
          for (let j = 0; j < section.TableAndBoxes.length; j++) {
            const table = section.TableAndBoxes[j];

            if (table.Type === "DrugTable") {
              result.push(section.TableAndBoxes[j]);
            }
          }
        }
      }

      return result;
    }
  },

  getAllTables(drugGuideline) {
    const result = [];

    if (drugGuideline.section !== undefined) {
      for (let i = 0; i < drugGuideline.sections.length; i++) {
        const section = drugGuideline.sections[i];

        if (section.TableAndBoxes !== undefined) {
          for (let j = 0; j < section.TableAndBoxes.length; j++) {
            result.push(section.TableAndBoxes[j]);
          }
        }
      }

      return result;
    }
  },

  tableAndBoxesReverse(tableAndBoxes, width, position, GLID, showTitle, reverse, selectedAge, trust, annotations) {
    let FEED2 = false;

    if (tableAndBoxes.FEED2 === "YES") {
      FEED2 = true;
    }

    let glTable = tableAndBoxes.rowColData;
    this.reorderDrugTable(glTable);

    let tableHTML = "";
    let numberOfColumns = glTable.length;
    let pageForAge = this.isPageForAge(GLID);

    if (selectedAge.months >= 0) {
      numberOfColumns = 2;
    }

    if (pageForAge) {
      numberOfColumns = glTable.length;
    }

    if (numberOfColumns > 8) {
      numberOfColumns = "Wide";
      width = 799;
    }

    tableHTML = `<div class=AACEDrugTableContainer id=${GLID}dosageTable${tableAndBoxes.ID}>`;

    if (numberOfColumns > 8) {
      numberOfColumns = "Wide";
    }

    // let ageRangeColumn = 0;

    if (showTitle) {
      tableHTML += `<div class=AACETableTitle>${tableAndBoxes.title}</div>`;

      if (tableAndBoxes.cpg_drug_short_info && tableAndBoxes.cpg_drug_short_info !== " (AT)") {
        tableHTML += `<div class=AACETableShortDrugInfo>${tableAndBoxes.cpg_drug_short_info}</div>`;
      }
    }

    // let idAdded = false;

    tableHTML +=
      '<div scrollbar-x="false" scrollbar-y="false" style="overflow: auto; padding-bottom: 10px; overflow-y: hidden;">';
    // tableHTML += "<div style=\"padding-bottom: 15px;\" has-bouncing=\"false\" direction=\"x\">"

    // idAdded = true;

    let rowsAdded = 0;

    const firstRow = glTable[0];
    let skipRowPosition = 0;

    if (firstRow.columns[0].text === "999" || firstRow.columns[0].text === "9999") {
      skipRowPosition = 1;
    }

    // SWAST annotation
    var drugName = this.columForDataType(firstRow.columns, "drug-name").text;
    var drugRoute = this.columForDataType(firstRow.columns, "drug-route").text;
    var drugMonths = "PFA-ignore";
    if (!pageForAge) {
      drugMonths = this.columForDataType(firstRow.columns, "drug-months").text;
    }

    var annotationText = this.drugDoseAnnotation(drugName, drugMonths, drugRoute, annotations);
    if (annotationText) {
      tableHTML += `<div class=SWASTNoteTitle>{$annotationText}</div><table class="ACCEDrugTablePFA${numberOfColums} SWASTTable">`;
    } else {
      tableHTML += `<table class=ACCEDrugTablePFA${numberOfColumns}>`;
    }

    let notes = [];

    if (FEED2) {
      let columnsToUseInOrder = [];
      let hasNoteText = this.doesTableHaveNoteText(glTable);
      let hasWeight = this.doesTableHaveWeightText(glTable);
      skipRowPosition = 0;

      if (tableAndBoxes.figuretype === "dosage8") {
        columnsToUseInOrder = [
          "drug-age",
          "drug-initialdose",
          "drug-repeatdose",
          "drug-repeatinterval",
          "drug-concentration",
          "drug-volume",
          "drug-max-dose",
        ];

        if (hasNoteText) {
          columnsToUseInOrder.push("drug-note");
        }

        if (hasWeight) {
          columnsToUseInOrder.splice(1, 0, "drug-weight");
        }
      }

      if (tableAndBoxes.figuretype === "dosage9") {
        columnsToUseInOrder = [
          "drug-age",
          "drug-weight",
          "drug-initialdose",
          "drug-repeatdose",
          "drug-repeatinterval",
          "drug-concentration",
          "drug-volume",
          "drug-max-dose",
        ];

        if (hasNoteText) {
          columnsToUseInOrder.push("drug-note");
        }
      }

      if (
        tableAndBoxes.figuretype === "quickref" ||
        tableAndBoxes.figuretype === "intravascular" ||
        tableAndBoxes.figuretype === "reversal" ||
        tableAndBoxes.figuretype === "cardiac"
      ) {
        columnsToUseInOrder = [
          "drug-name",
          "drug-route",
          "drug-initialdose",
          "drug-repeatdose",
          "drug-repeatinterval",
          "drug-concentration",
          "drug-volume",
          "drug-max-dose",
        ];

        if (hasNoteText) {
          columnsToUseInOrder.push("drug-note");
        }

        skipRowPosition = 0;
      }

      if (!reverse) {
        for (let i = skipRowPosition; i < columnsToUseInOrder.length; i++) {
          tableHTML += "<tr>";

          for (let j = 0; j < glTable.length; j++) {
            let row = glTable[j];
            let range = -1;
            let drugAge = this.columnForDataType(row.columns, "drug-age").text;
            let drugName = this.columnForDataType(row.columns, "drug-name").text;
            var drugRoute = this.columForDataType(row.columns, "drug-route").text;
            let drugMonthsObject = this.columnForDataType(row.columns, "drug-months");
            let drugMonths = "";

            if (drugMonthsObject) {
              drugMonths = drugMonthsObject.text;
            }

            let annotationText = this.drugDoseAnnotation(drugName, drugMonths, drugRoute, annotations);
            let column = this.columnForDataType(row.columns, columnsToUseInOrder[i]);

            if (annotationText === "Hide JRCALC?") {
              column = undefined;
            }

            range = row.columns[0].text;

            if (column) {
              if (pageForAge || this.isDateInRange(range, selectedAge)) {
                if (selectedAge.name === "At Birth" || selectedAge.name === "Post birth to 1 month") {
                  // if selectedAge is 'At Birth' and there is both a 'Birth' and 'At Birth' row, skip the Birth row
                  // check if there is both an 'At Birth' and 'Birth' row
                  let atBirthRow = glTable.find(
                    (row) => this.columForDataType(row.columns, "drug-age").text.toLowerCase() === "at birth"
                  );
                  let birthRow = glTable.find(
                    (row) =>
                      this.columForDataType(row.columns, "drug-months").text.toLowerCase() === "0-1" &&
                      this.columForDataType(row.columns, "drug-age").text.toLowerCase() !== "at birth"
                  );
                  if (
                    selectedAge.name === "At Birth" &&
                    atBirthRow &&
                    birthRow &&
                    drugMonths.toLowerCase() === "0-1" &&
                    drugAge.toLowerCase() !== "at birth"
                  ) {
                    // skip birth column;
                    continue;
                  } else if (
                    selectedAge.name === "Post birth to 1 month" &&
                    atBirthRow &&
                    birthRow &&
                    drugAge.toLowerCase() === "at birth"
                  ) {
                    // skip at birth column;
                    continue;
                  }
                }
                if (i === skipRowPosition) {
                  if (annotationText && j > 0) {
                    let columnText = this.removeNote(column.text, notes);
                    tableHTML += `<td class=${trust}Anno>`;
                    tableHTML += `<div class=${trust}DrugAnnoText><div>${columnText}</div>${annotationText}</div>`;
                  } else {
                    tableHTML += `<th id=th-${tableAndBoxes.ID}-${j} value=${range}>`;
                    // tableHTML += `<th onClick="console.log('${tableAndBoxes.ID} - ${i} - ${j}')">`;
                    let columnText = this.removeNote(column.text, notes);
                    tableHTML += columnText;
                    tableHTML += "</th>\n";
                  }
                } else {
                  tableHTML += `<td id=td-${tableAndBoxes.ID}>`;
                  // tableHTML += `<td onClick="console.log('${tableAndBoxes.ID} - ${i} - ${j}')">`;
                  let columnText = this.removeNote(column.text, notes);
                  tableHTML += columnText;
                  tableHTML += "</td>\n";
                }

                if (j > 0) {
                  rowsAdded++;
                }
              }
            }
          }

          tableHTML += "</tr>\n";
        }
      } else {
        // other way round
        for (let i = 0; i < glTable.length; i++) {
          let row = glTable[i];
          let column = this.columnForDataType(row.columns, columnsToUseInOrder[i]);
          let drugName = this.columnForDataType(row.columns, "drug-name");
          let drugMonths = this.columnForDataType(row.columns, "drug-months");
          var drugRoute = this.columForDataType(row.columns, "drug-route");
          let annotationText = null;
          if (drugName && drugMonths) {
            annotationText = this.drugDoseAnnotation(drugName.text, drugMonths.text, drugRoute.text, annotations);
          }

          if (annotationText !== "Hide JRCALC?") {
            if (annotationText) {
              tableHTML += `<tr class="${trust}PFARow">`;
            } else {
              tableHTML += `<tr>`;
            }

            for (let j = 0; j < columnsToUseInOrder.length; j++) {
              // let skipColumn = false;
              let column = this.columnForDataType(row.columns, columnsToUseInOrder[j]);

              if (column) {
                if (i === 0) {
                  if (tableAndBoxes.figuretype === "quickref") {
                    tableHTML += "<th class='quickrefHeader'>";
                  } else if (pageForAge) {
                    tableHTML += "<th class='pageForAgeTableHeader'>";
                  } else {
                    tableHTML += "<th>";
                  }

                  let columnText = this.removeNote(column.text, notes);
                  tableHTML += columnText;
                  tableHTML += "</th>\n";
                } else {
                  if (annotationText && j === 0) {
                    let columnText = this.removeNote(column.text, notes);
                    tableHTML += `<td id=td-${tableAndBoxes.ID}-${i} class=${trust}Anno>`;
                    tableHTML += `<div class=${trust}DrugAnnoTextPFA><div>${columnText}</div>${annotationText}</div>`;
                    if (
                      (tableAndBoxes.figuretype === "intravascular" ||
                        tableAndBoxes.figuretype === "cardiac" ||
                        tableAndBoxes.figuretype === "quickref") &&
                      j === 0
                    ) {
                      tableHTML += `<img style="margin-left: 2px; margin-right: 2px; margin-bottom: -16px;" height="44" src="img/Button_Fullscreen@3x.png"/>`;
                    }
                  } else {
                    tableHTML += `<td id=td-${tableAndBoxes.ID}-${i}>`;
                    let columnText = this.removeNote(column.text, notes);
                    tableHTML += columnText;
                    if (
                      (tableAndBoxes.figuretype === "intravascular" ||
                        tableAndBoxes.figuretype === "cardiac" ||
                        tableAndBoxes.figuretype === "quickref") &&
                      j === 0
                    ) {
                      tableHTML += `<img style="margin-left: 2px; margin-right: 2px; margin-bottom: -16px;" height="44" src="img/Button_Fullscreen@3x.png"/>`;
                    }
                    tableHTML += "</td>\n";
                  }
                }
              }
            }
            tableHTML += "</tr>\n";
            rowsAdded++;
          }
        }
      }
    } else {
      if (!reverse) {
        // NOT FEED2 old table data format.
        for (let i = skipRowPosition; i < firstRow.columns.length; i++) {
          tableHTML += "<tr>";

          for (let j = 0; j < glTable.length; j++) {
            let row = glTable[j];
            let range = -1;

            if (skipRowPosition > 0) {
              range = row.columns[0].text;
            }

            if (pageForAge || this.isDateInRange(range, selectedAge)) {
              if (i === skipRowPosition) {
                tableHTML += "<th>";
                let columnText = this.removeNote(row.columns[i].text, notes);
                tableHTML += columnText;
                tableHTML += "</th>\n";
              } else {
                tableHTML += "<td>";
                let columnText = this.removeNote(row.columns[i].text, notes);
                tableHTML += columnText;
                tableHTML += "</td>\n";
              }

              if (j > 0) {
                rowsAdded++;
              }
            }
          }

          tableHTML += "</tr>\n";
        }
      } else {
        // other way round
        for (let i = 0; i < glTable.length; i++) {
          let row = glTable[i];
          tableHTML += `<tr>`;

          for (let j = 0; j < row.columns.length; j++) {
            if (i === 0) {
              tableHTML += "<th>";
              let columnText = this.removeNote(row.columns[j].text, notes);
              tableHTML += columnText;
              tableHTML += "</th>\n";
            } else {
              if (j === 0) {
                tableHTML += "<td class='blueUnderLine'>";
              } else {
                tableHTML += "<td>";
              }
              let columnText = this.removeNote(row.columns[j].text, notes);
              tableHTML += columnText;
              tableHTML += "</td>\n";
            }
          }

          tableHTML += "</tr>\n";
          rowsAdded++;
        }
      }
    }

    if (rowsAdded === 0) {
      // no matching data for age group??
      let pointToReplace = tableHTML.indexOf("<table class=ACCEDrugTablePFA");
      tableHTML = tableHTML.substr(0, pointToReplace);
      tableHTML +=
        "<div>It is NOT recommended to administer this drug to a person in the age range you have selected. See the full guideline for age restrictions</div>";
    } else {
      tableHTML += "</table>";
      tableHTML += `<div class=AACETableTitle>${tableAndBoxes.table_note}</div>`;
    }

    tableHTML += "</div>";

    if (notes.length > 0) {
      tableHTML += "<div class=AACEDrugTableNotes>NOTES: ";

      for (let i = 0; i < notes.length; i++) {
        tableHTML += notes[i];
      }

      tableHTML += "</div>";
    }

    tableHTML += "</div>";

    tableHTML = "<hr class='AACEDrugRouteDivider'>" + tableHTML;

    return tableHTML;
  },

  doesTableHaveAnyColumns(glTable, annotations) {
    let columnsToShowCount = 0;

    for (let j = 0; j < glTable.length; j++) {
      let row = glTable[j];
      let range = -1;

      let drugName = this.columnForDataType(row.columns, "drug-name").text;
      var drugRoute = this.columForDataType(row.columns, "drug-route").text;
      let drugMonthsObject = this.columnForDataType(row.columns, "drug-months");
      let drugMonths = "";

      if (drugMonthsObject) {
        drugMonths = drugMonthsObject.text;
      }

      let annotationText = this.drugDoseAnnotation(drugName, drugMonths, drugRoute, annotations);

      if (annotationText !== "Hide JRCALC?") {
        columnsToShowCount++;
      }
    }

    return columnsToShowCount > 1;
  },

  reorderDrugTable(tableRowsAndColumns) {
    try {
      var lastItem = tableRowsAndColumns[tableRowsAndColumns.length - 1];

      if (lastItem.columns[0].text === "9999") {
        tableRowsAndColumns.unshift(tableRowsAndColumns.pop());
      }
    } catch (error) {
      console.log(error);
    }
  },

  removeNote(columnText, notes) {
    let result = columnText;
    let note = this.getHTMLElement(columnText, "note");
    let noteRef = this.getHTMLElement(columnText, "note_ref");

    while (note.length > 0) {
      if (noteRef.length > 0) {
        notes.push(noteRef);
      }

      notes.push(note);
      result = result.replace(note, "");
      note = this.getHTMLElement(result, "note");

      if (note.length > 0) {
        let nextNoteRef = result.slice(result.indexOf(noteRef) + noteRef.length);
        noteRef = this.getHTMLElement(nextNoteRef, "note_ref");
      }
    }

    return result;
  },

  getHTMLElement(html, elementName) {
    let start = `<${elementName}>`;
    let startPosition = html.indexOf(start);

    if (startPosition === -1) {
      start = `<${elementName} `;
      startPosition = html.indexOf(start);
    }

    let end = `</${elementName}>`;
    let endPosition = html.indexOf(end);

    if (startPosition !== -1 && endPosition !== -1 && endPosition > startPosition) {
      let result = html.substring(startPosition, endPosition + end.length);

      return result;
    }

    return "";
  },

  columnForDataType(columns, dataType) {
    try {
      for (let i = 0; i < columns.length; i++) {
        let column = columns[i];

        if (column.dataType === dataType) {
          return column;
        }
      }
    } catch (error) {
      console.log(error);
    }

    return null;
  },

  doesTableHaveNoteText(glTable) {
    let result = false;

    try {
      for (let i = 0; i < glTable.length; i++) {
        let entry = glTable[i];
        let columns = entry.columns;

        columns.forEach((column) => {
          if (column.dataType === "drug-note") {
            if (column.text.length > 0 && column.text !== "NOTE") {
              result = true;
            }
          }
        });

        if (result) {
          break;
        }
      }
    } catch (error) {
      console.log(error);
    }

    return result;
  },

  doesTableHaveWeightText(glTable) {
    let result = false;

    try {
      for (let i = 0; i < glTable.length; i++) {
        let entry = glTable[i];
        let columns = entry.columns;

        columns.forEach((column) => {
          if (column.dataType === "drug-weight") {
            if (column.text.length > 0 && column.text !== "WEIGHT") {
              result = true;
            }
          }
        });

        if (result) {
          break;
        }
      }
    } catch (error) {
      console.log(error);
    }

    return result;
  },

  isPageForAge(GLID) {
    return GLID.indexOf("P0") === 0;
  },

  columForDataType(columns, adataType) {
    try {
      for (var w = 0; w < columns.length; ++w) {
        var aCol = columns[w];
        if (aCol["dataType"] === adataType) {
          return aCol;
        }
      }
    } catch (e) {
      console.log(e);
    }
    return null;
  },

  drugDoseAnnotation(drugName, drugAge, drugRoute, annotations) {
    var result = null;
    for (var i = 0; i < annotations.length; i++) {
      var anAnnotation = annotations[i];
      if (anAnnotation.Reference) {
        if (anAnnotation.Reference === drugName) {
          let annotationApplies = true;

          if (anAnnotation.Age && anAnnotation.Age !== "" && anAnnotation.Age !== drugAge) {
            annotationApplies = false;
          }
          if (anAnnotation.Route && anAnnotation.Route !== "" && anAnnotation.Route !== drugRoute) {
            annotationApplies = false;
          }
          if (annotationApplies) {
            if (anAnnotation["Hide JRCALC?"] === "true") {
              result = "Hide JRCALC?";
            } else {
              result = anAnnotation["note (html)"];
            }
          }
        }
      }
    }
    return result;
  },

  isDateInRange(range, age) {
    Number.prototype.between = function (a, b, inclusive) {
      let min = Math.min(a, b);
      let max = Math.max(a, b);

      return inclusive ? this >= min && this <= max : this > min && this < max;
    };

    if (range === -1) {
      return true;
    }

    let div = document.createElement("div");
    let result = false;
    div.innerHTML = range;
    let rangeString = div.textContent || div.innerHTML || "";

    try {
      let rangeValue = range.split("-");
      let minRange = parseInt(rangeValue[0], 10);
      let maxRange = parseInt(rangeValue[1], 10);

      if (rangeValue.length === 1) {
        maxRange = minRange;
      }

      let ageRangeValue = age.range.split("-");
      let ageMinRange = parseInt(ageRangeValue[0], 10);
      let ageMaxRange = parseInt(ageRangeValue[1], 10);

      if (age.name === "18+") {
        if (maxRange === 839) {
          maxRange = 9999;
        }
        if (minRange === 840) {
          minRange = 216;
        }
      }

      if (age.name === "12 to adult") {
        if (maxRange === 839) {
          maxRange = 9999;
        }
      }

      if (ageMinRange >= minRange) {
        if (ageMaxRange <= maxRange) {
          result = true;
        }
      }
    } catch (error) {
      console.log(error);
    }

    if (age.months === -1) {
      result = true;
    }
    if (rangeString === "999" || rangeString === "9999") {
      result = true;
    }

    return result;
  },
};
